import * as Storage from "../lib/Storage.ts";

const FEATURES = {
  'newfeatures.specialdays': {limit:new Date('2025-12-31')},
  'specialdays.onboarding': {limit:new Date('2030-12-31')},
  'filer.onboarding': {limit:new Date('2030-12-31')},
  'filer.subfolder': {limit:new Date('2030-12-31')},
  'budget.markaspaid':{limit:new Date('2024-12-31')},
  'calendar.aiimport':{limit:new Date('2026-12-31')},
  'tasklist.pin':{limit:new Date('2026-12-31')},
  'tasklist.deletesystem':{limit:new Date('2026-12-31')},
  'tasklist.quantity':{limit:new Date('2027-12-31')},

}
type FeatureKey = keyof typeof FEATURES;

export function hasSeen(key :FeatureKey) :boolean{
  if(Storage.sessionGet('logfromdeeplink')==='true'){
    return true;
  }
  let feature = FEATURES[key];
  if(!feature){
    console.log('No feature '+key);
    return true;
  }
  if(new Date()>feature.limit){
    return true;
  }
  return Storage.localGet("feature."+key)==='true';
}

export function markSeen(key :FeatureKey) :void{
  Storage.localSet("feature."+key,'true');
}